var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Button from '@telia-front/button';
import { useResponsiveProps, debounce } from '@telia-front/helper';
import { useLabels } from '@telia-front/label-provider';
const ScrollToTopButtonResponsive = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    const responsiveProps = useResponsiveProps({ responsive });
    return React.createElement(ScrollToTopButtonInner, Object.assign({}, rest, responsiveProps));
};
const ScrollToTopButtonInner = (props) => {
    var _a, _b;
    const { button, bottom = '1rem', right = '1rem', scrollPosition = 100 } = props;
    const labels = useLabels();
    const scrollTopLabel = ((_a = props.button) === null || _a === void 0 ? void 0 : _a.text) || labels.get('scrollTop');
    const scrollTopIcon = ((_b = props.button) === null || _b === void 0 ? void 0 : _b.icon) || '#arrow-up';
    const [isVisible, setIsVisible] = React.useState(false);
    React.useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > scrollPosition) {
                setIsVisible(true);
            }
            else {
                setIsVisible(false);
            }
        };
        const scrollHandler = debounce(handleScroll, 100);
        window.addEventListener('scroll', scrollHandler);
        return () => {
            window.removeEventListener('scroll', scrollHandler);
            scrollHandler.clear();
        };
    }, [scrollPosition]);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    return (React.createElement("div", { className: "scroll-to-top-button", style: {
            bottom: bottom,
            right: right,
            display: isVisible ? 'block' : 'none',
        } },
        React.createElement(Button, Object.assign({}, button, { text: scrollTopLabel, icon: scrollTopIcon, onClick: scrollToTop }))));
};
const ScrollToTopButton = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    return responsive ? React.createElement(ScrollToTopButtonResponsive, Object.assign({}, rest, { responsive: responsive })) : React.createElement(ScrollToTopButtonInner, Object.assign({}, rest));
};
export default ScrollToTopButton;
